import React from 'react'

import { LayoutEditorWidgetControlsErrorBoundary } from 'features/views/LayoutEditor/LayoutEditorWidgetControlsErrorBoundary'

import { Box } from 'ui/components/Box'
import { Icon } from 'ui/components/Icon'
import { Body, Headline } from 'ui/components/Text'

import { useLayoutEditorWidgetControlsState } from './hooks/useLayoutEditorWidgetControlsState'
import { LayoutEditorDetailPane } from './LayoutEditorDetailPane'

type LayoutEditorWidgetControlsProps = {}

export const LayoutEditorWidgetControls: React.FC<LayoutEditorWidgetControlsProps> = () => {
    const {
        Component,
        selectedWidget,
        onBackClick,
        onChangeWidgetAttrs,
        label,
        closeDetailPane,
        openDetailPane,
        isEditAllowed,
    } = useLayoutEditorWidgetControlsState()

    if (!selectedWidget) return null

    return (
        <LayoutEditorDetailPane title={label} onBackClick={onBackClick}>
            <LayoutEditorWidgetControlsErrorBoundary key={Component?.name}>
                {isEditAllowed && Component && (
                    <Component
                        key={selectedWidget.id}
                        widget={selectedWidget}
                        onChange={onChangeWidgetAttrs}
                        openDetailPane={openDetailPane}
                        closeDetailPane={closeDetailPane}
                    />
                )}
                {isEditAllowed && !Component && <Box />}
                {!isEditAllowed && (
                    <Box px="l" width="full">
                        <Box
                            flex
                            column
                            gap="xs"
                            p="m"
                            borderStyle="dashed"
                            borderColor="borderDisabled"
                            borderWidth={1}
                            background="surfaceDisabled"
                            rounded="m"
                        >
                            <Icon size="xl" name="Lock" color="warning700" mb="s" />
                            <Headline size="2xs" color="warning700">
                                Insufficient permissions
                            </Headline>
                            <Body size="s">
                                Please contact Stacker support to edit this widget.
                            </Body>
                        </Box>
                    </Box>
                )}
            </LayoutEditorWidgetControlsErrorBoundary>
        </LayoutEditorDetailPane>
    )
}
